<template>
    <div style="background-color: white;">
        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NT52kFn.png" width="100%" />
        <div style="text-align:center;margin:2rem 0;">
            <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NT4VLV6.png" width="50%" />
        </div>
        <div style="width:90%;margin:0 auto;">
            扫码-填写姓名+手机号-开通-填手机号-实名认证-生成卡号-微信支付-绑定生成卡号-微信-手机充值-充值30减29-记得提醒用户还款
        </div>
        <div style="text-align:center; margin: 3rem 0;">
            <van-field v-model="query.phone" type="number" label="手机号" placeholder="请输入手机号" class="input" />
            <van-button type="primary" size="normal" @click="simpleJobOrderDeclare" class="declareButton">点击报单</van-button>
        </div>
        <div style="width:90%;margin:0 auto;">
            注意事项：<br/>
            1.此界面输入手机号必须和乐花卡拉新手机号一致，否则会影响拉新数据<br/>
            2.新用户在活动页面验证手机号,在乐花卡完成实名出卡号-微信绑定卡号（必须完成）-充值话费
        </div>
    </div>
</template>

<script>
    import mainAPI from '@/api/main';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    jobId: this.$route.query.jobId,
                    traderId: this.$route.query.traderId,
                    jobLinkUpPid: this.$route.query.pid,
                    phone: '',
                },
            }
        },
        methods: {
            simpleJobOrderDeclare() {
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("请输入正确的手机号");
                    return;
                }
                mainAPI.simpleJobOrderDeclare(this.query).then(() => {
                    this.$toast("上报成功");
                    this.query.phone = '';
                }).catch(() => {
                });
            },
        },
        created() {
        },
        mounted() {
            pvuvAPI.addPv("jobDeclare/lhkDeclare", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>

    .input {
        height: 5rem;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .declareButton {
        width: 15rem;
        font-size: 1.5rem;
        font-weight: bold;
        color: #FFFFFF;
    }

</style>
